import { MoneyConnectClientAPI } from "./axios-service-creator";

export const LombardAPI = {
  getLombardPortId: () => MoneyConnectClientAPI.get("/lombard/portfolio/id"),
  getLombardTransactions: (params) => MoneyConnectClientAPI.get("/lombard/portfolio/transaction", { params }),
};
